import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Text } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { PropertyRow } from '@bingads-webui-campaign-react/ui-generator';

export const Feeds = ({ feedLabel }) => {
  const i18n = useContext(I18nContext);
  const feedLabelsText = i18n.getString(_TL_('Filter by feed label: {{feedLabel}}'), { feedLabel });

  return (
    <PropertyRow propertyLabel={{ label: _TL_('Feeds') }}>
      <Text>{feedLabelsText}</Text>
    </PropertyRow>
  );
};

Feeds.propTypes = {
  feedLabel: PropTypes.string.isRequired,
};
